import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'


const styles = {
  root: {
    textAlign: 'center',
  },
  centered: {
    width: '100%',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  inline: {
    display: 'flex',
    alignItems: 'center',

    '& > *:first-child': {
      marginRight: 20,
    },
  },
}


const Loading = ({
  text,
  size,
  color,
  inline,
  centered,
  classes,
  children,
  className,
  typographyVariant,
  typographyClassName,
  ...props
}) => {
  if (!text) {
    return (
      <CircularProgress
        size={size}
        color={color}
        className={className}
        {...props}
      />
    )
  }

  return (
    <div
      className={classNames(classes.root, {
        [classes.centered]: centered,
        [classes.inline]: inline,
      }, className)}
      {...props}
    >
      <CircularProgress color={color} size={size} />
      <Typography className={typographyClassName} color={color} variant={typographyVariant}>{text}</Typography>
      {children}
    </div>
  )
}


Loading.defaultProps = {
  inline: false,
  color: 'primary',
  typographyVariant: 'h5',
  typographyClassName: 'mt1',
}


Loading.propTypes = {
  color: PropTypes.string,
  text: PropTypes.string,
  size: PropTypes.number,
  inline: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  typographyClassName: PropTypes.string,
  typographyVariant: PropTypes.string,
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(Loading)
